var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{on:{"change":_vm.changeTerm}},_vm._l((_vm.termFilters),function(term,index){return _c('option',{key:term.value,domProps:{"value":term.value,"selected":term.value === _vm.value || index === 0}},[_vm._v(" "+_vm._s(_vm.$t(term.label))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }